import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getConnection, Repository } from 'typeorm';
import { PointsResponseModel, SingleResponseModel } from '../post/dto/post-response-model';
import { PostEntity } from '../post/post.entity';
import { PollVotingDto } from './dto/poll.dto';
import { PollVotingEntity } from './poll-voting.entity';
import { PollEntity } from './poll.entity';

@Injectable()
export class PollService {
    constructor (
        @InjectRepository(PollEntity)
        private pollRepo:Repository<PollEntity>,
        @InjectRepository(PollVotingEntity)
        private polVotRepo:Repository<PollVotingEntity>,
        @InjectRepository(PostEntity)
        private postRepo:Repository<PostEntity>,
    ) {}

    async createPostPoll(pollData) {
        try {
            const savedPostfiles = await this.pollRepo.save(pollData);
            if(savedPostfiles) {
                return true;
            } else { 
                return null;
            }
        } catch (error) {
            throw error;
        }
    }

    async deletePostPoll(postId) {
        try {
            const delres = await this.pollRepo.delete({postId:postId}) 
            if(delres) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            throw error;
        }
    }

    async getPostPoll(postId) {
        try {
            const data = await this.pollRepo.find({
                where:{postId:postId,status:true}
            })
            if(data) {
                return data;
            } else {
                return null;
            }
        } catch (error) {
            throw error;
        }
    }

    async pollVoting(queryParams,pollvotDto:PollVotingDto,request:Request): Promise<SingleResponseModel> {
        const response = new SingleResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const checkOld = await this.polVotRepo.findOne({
                    where:{postId:pollvotDto.postId, userId:pollvotDto.userId}
                });
                if(checkOld) {
                    const updateVote = await this.polVotRepo.update(
                        {postId:pollvotDto.postId, userId:pollvotDto.userId},
                        {pollId:pollvotDto.pollId}
                    );
                    if(updateVote) {
                        const getPoll = await this.pollRepo.find({
                            where:{postId:pollvotDto.postId,status:true}
                        })
                        const pollTotal = await getConnection()
                        .createQueryBuilder()
                        .select("count(*) as cnt")
                        .from(PollVotingEntity, "PollVoting")
                        .where('post_id=:da', { da: pollvotDto.postId })
                        .orderBy('status','ASC')
                        .getRawOne();
                        const tlCount = pollTotal.cnt;
                        const finData: any[] = [];
                        const promises = getPoll.map(async (v) => {
                            const optionTotal = await getConnection()
                            .createQueryBuilder()
                            .select("count(*) as cnt")
                            .from(PollVotingEntity, "PollVoting")
                            .where('post_id=:da', { da: pollvotDto.postId })
                            .andWhere('poll_id=:pi',{pi:v.Id})
                            .orderBy('status','ASC')
                            .getRawOne();
                            const statusTotal = await getConnection()
                            .createQueryBuilder()
                            .select("count(*) as cnt")
                            .from(PollVotingEntity, "PollVoting")
                            .where('post_id=:da', { da: pollvotDto.postId })
                            .andWhere('poll_id=:pi',{pi:v.Id})
                            .andWhere('user_id=:ui',{ui:pollvotDto.userId})
                            .orderBy('status','ASC')
                            .getRawOne();                        
                            return  {
                                pollId:v.Id,
                                pollValue:v.pollValue,
                                pollType:v.pollType,
                                polCnt: optionTotal.cnt,
                                usta: statusTotal.cnt > 0 ? true : false
                            }
                        })
                        const da = await Promise.all(promises);
                        da.map((f) => { 
                            finData.push({
                                pollId: f.pollId,
                                pollType:f.pollType,
                                pollValue:f.pollValue,
                                totalCount:tlCount,
                                pollCount:f.polCnt,
                                percentage: tlCount == 0 ? 0 : Math.round(f.polCnt / (tlCount / 100)),
                                userStatus: f.usta
                            })
                        });   
                        response.status = true;
                        response.data   = finData;
                        response.statusCode = 50000;
                        response.internalMessage = 'vote casted successfully';
                        response.intlCode = 11100;
                    } else { 
                        throw new ErrorResponse(11106, 'vote not saved')
                    }
                } else {
                    const savedVote = await this.polVotRepo.save(pollvotDto);
                    if(savedVote) {
                        const getPoll = await this.pollRepo.find({
                            where:{postId:pollvotDto.postId,status:true}
                        })
                        const pollTotal = await getConnection()
                        .createQueryBuilder()
                        .select("count(*) as cnt")
                        .from(PollVotingEntity, "PollVoting")
                        .where('post_id=:da', { da: pollvotDto.postId })
                        .orderBy('status','ASC')
                        .getRawOne();
                        const tlCount = pollTotal.cnt;
                        const finData: any[] = [];
                        const promises = getPoll.map(async (v) => {
                            const optionTotal = await getConnection()
                            .createQueryBuilder()
                            .select("count(*) as cnt")
                            .from(PollVotingEntity, "PollVoting")
                            .where('post_id=:da', { da: pollvotDto.postId })
                            .andWhere('poll_id=:pi',{pi:v.Id})
                            .orderBy('status','ASC')
                            .getRawOne();
                            const statusTotal = await getConnection()
                            .createQueryBuilder()
                            .select("count(*) as cnt")
                            .from(PollVotingEntity, "PollVoting")
                            .where('post_id=:da', { da: pollvotDto.postId })
                            .andWhere('poll_id=:pi',{pi:v.Id})
                            .andWhere('user_id=:ui',{ui:pollvotDto.userId})
                            .orderBy('status','ASC')
                            .getRawOne();                        
                            return  {
                                pollId:v.Id,
                                pollValue:v.pollValue,
                                pollType:v.pollType,
                                polCnt: optionTotal.cnt,
                                usta: statusTotal.cnt > 0 ? true : false
                            }
                        })
                        const da = await Promise.all(promises);
                        da.map((f) => { 
                            finData.push({
                                pollId: f.pollId,
                                pollType:f.pollType,
                                pollValue:f.pollValue,
                                totalCount:tlCount,
                                pollCount:f.polCnt,
                                percentage: tlCount == 0 ? 0 : Math.round(f.polCnt / (tlCount / 100)),
                                userStatus: f.usta
                            })
                        });   
                        response.status = true;
                        response.data   = finData;
                        response.statusCode = 50000;
                        response.internalMessage = 'vote casted successfully';
                        response.intlCode = 11100;
                    } else { 
                        throw new ErrorResponse(11106, 'vote not saved')
                    } 
                }               
            } else {
                const checkOld = await this.polVotRepo.findOne({
                    where:{postId:pollvotDto.postId, userId:pollvotDto.userId}
                });
                if(checkOld) {
                    const updateVote = await this.polVotRepo.update(
                        {postId:pollvotDto.postId, userId:pollvotDto.userId},
                        {pollId:pollvotDto.pollId}
                    );
                    if(updateVote) {
                        const getPoll = await this.pollRepo.find({
                            where:{postId:pollvotDto.postId,status:true}
                        })
                        const pollTotal = await getConnection()
                        .createQueryBuilder()
                        .select("count(*) as cnt")
                        .from(PollVotingEntity, "PollVoting")
                        .where('post_id=:da', { da: pollvotDto.postId })
                        .orderBy('status','ASC')
                        .getRawOne();
                        const tlCount = pollTotal.cnt;
                        const finData: any[] = [];
                        const promises = getPoll.map(async (v) => {
                            const optionTotal = await getConnection()
                            .createQueryBuilder()
                            .select("count(*) as cnt")
                            .from(PollVotingEntity, "PollVoting")
                            .where('post_id=:da', { da: pollvotDto.postId })
                            .andWhere('poll_id=:pi',{pi:v.Id})
                            .orderBy('status','ASC')
                            .getRawOne();
                            const statusTotal = await getConnection()
                            .createQueryBuilder()
                            .select("count(*) as cnt")
                            .from(PollVotingEntity, "PollVoting")
                            .where('post_id=:da', { da: pollvotDto.postId })
                            .andWhere('poll_id=:pi',{pi:v.Id})
                            .andWhere('user_id=:ui',{ui:pollvotDto.userId})
                            .orderBy('status','ASC')
                            .getRawOne();                        
                            return  {
                                pollId:v.Id,
                                pollValue:v.pollValue,
                                pollType:v.pollType,
                                polCnt: optionTotal.cnt,
                                usta: statusTotal.cnt > 0 ? true : false
                            }
                        })
                        const da = await Promise.all(promises);
                        da.map((f) => { 
                            finData.push({
                                pollId: f.pollId,
                                pollType:f.pollType,
                                pollValue:f.pollValue,
                                totalCount:tlCount,
                                pollCount:f.polCnt,
                                percentage: tlCount == 0 ? 0 : Math.round(f.polCnt / (tlCount / 100)),
                                userStatus: f.usta
                            })
                        });   
                        response.status = true;
                        response.data   = finData;
                        response.statusCode = 50000;
                        response.internalMessage = 'vote casted successfully';
                        response.intlCode = 11100;
                    } else { 
                        throw new ErrorResponse(11106, 'vote not saved')
                    }
                } else {
                    const savedVote = await this.polVotRepo.save(pollvotDto);
                    if(savedVote) {
                        const getPoll = await this.pollRepo.find({
                            where:{postId:pollvotDto.postId,status:true}
                        })
                        const pollTotal = await getConnection()
                        .createQueryBuilder()
                        .select("count(*) as cnt")
                        .from(PollVotingEntity, "PollVoting")
                        .where('post_id=:da', { da: pollvotDto.postId })
                        .orderBy('status','ASC')
                        .getRawOne();
                        const tlCount = pollTotal.cnt;
                        const finData: any[] = [];
                        const promises = getPoll.map(async (v) => {
                            const optionTotal = await getConnection()
                            .createQueryBuilder()
                            .select("count(*) as cnt")
                            .from(PollVotingEntity, "PollVoting")
                            .where('post_id=:da', { da: pollvotDto.postId })
                            .andWhere('poll_id=:pi',{pi:v.Id})
                            .orderBy('status','ASC')
                            .getRawOne();
                            const statusTotal = await getConnection()
                            .createQueryBuilder()
                            .select("count(*) as cnt")
                            .from(PollVotingEntity, "PollVoting")
                            .where('post_id=:da', { da: pollvotDto.postId })
                            .andWhere('poll_id=:pi',{pi:v.Id})
                            .andWhere('user_id=:ui',{ui:pollvotDto.userId})
                            .orderBy('status','ASC')
                            .getRawOne();                        
                            return  {
                                pollId:v.Id,
                                pollValue:v.pollValue,
                                pollType:v.pollType,
                                polCnt: optionTotal.cnt,
                                usta: statusTotal.cnt > 0 ? true : false
                            }
                        })
                        const da = await Promise.all(promises);
                        da.map((f) => { 
                            finData.push({
                                pollId: f.pollId,
                                pollType:f.pollType,
                                pollValue:f.pollValue,
                                totalCount:tlCount,
                                pollCount:f.polCnt,
                                percentage: tlCount == 0 ? 0 : Math.round(f.polCnt / (tlCount / 100)),
                                userStatus: f.usta
                            })
                        });   
                        response.status = true;
                        response.data   = finData;
                        response.statusCode = 50000;
                        response.internalMessage = 'vote casted successfully';
                        response.intlCode = 11100;
                    } else { 
                        throw new ErrorResponse(11106, 'vote not saved')
                    } 
                }               
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async leaderBoard(queryParams,request:Request):Promise<PointsResponseModel> {
        const response = new PointsResponseModel();
        const finalData: any[] = [];
        try {
            if(queryParams.apiVersion == 1) {
                const data = await getConnection()
                .createQueryBuilder()
                .select("count(*) as cnt,poll_id,post_id")
                .from(PollVotingEntity, "PollVoting")
                .where('status=:da', { da: true })
                .groupBy('poll_id')
                .orderBy('cnt','DESC')
                .getRawMany();
                if(!data) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const promises = data.map(async (post) => {
                    //console.log('p',post);
                    //const user = await this.profileService.getUserByUId(post.id);
                    const PollDa = await this.pollRepo.findOne({
                        where:{Id:post.poll_id}
                    })
                    const postDa = await this.postRepo.findOne({
                        where:{Id:post.post_id, status:true}
                    })
                   // console.log(postDa)
                    if(postDa != undefined) {
                        return {
                            userId:0,
                            userName: PollDa.pollValue != null ? PollDa.pollValue :'',
                            profilePic:'',
                            points:0,
                            likeCount: '0',
                            cmntCount:'0',
                            shareCount:'0',
                            imgCount:'0',
                            videoCount:'0',
                            pollCount:post.cnt != null?post.cnt:0,
                            total:post.cnt != null?post.cnt:0,
                        }
                    }
                       
                });   
                const da = await Promise.all(promises);
                da.map((f) => {
                    if(f) {
                        finalData.push({
                            userId:f.userId,
                            userName: f.userName,
                            profilePic:f.profilePic ,
                            points:f.points,
                            likeCount:f.likeCount,
                            cmntCount:f.cmntCount,
                            shareCount:f.shareCount,
                            imgCount:f.imgCount,
                            videoCount:f.videoCount,
                            pollCount:f.pollCount,
                            total:f.total                        
                        })
                    }     
                }) 
                if(finalData.length > 0) {
                    response.status = true;
                    response.data = finalData;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99908,'Data not found')
                }
                
            }  else {
                const data = await getConnection()
                .createQueryBuilder()
                .select("count(*) as cnt,poll_id,post_id")
                .from(PollVotingEntity, "PollVoting")
                .where('status=:da', { da: true })
                .groupBy('poll_id')
                .orderBy('cnt','DESC')
                .getRawMany();
                if(!data) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const promises = data.map(async (post) => {
                    //console.log('p',post);
                    //const user = await this.profileService.getUserByUId(post.id);
                    const PollDa = await this.pollRepo.findOne({
                        where:{Id:post.poll_id}
                    })
                    const postDa = await this.postRepo.findOne({
                        where:{Id:post.post_id, status:true}
                    })
                   // console.log(postDa)
                    if(postDa != undefined) {
                        return {
                            userId:0,
                            userName: PollDa.pollValue != null ? PollDa.pollValue :'',
                            profilePic:'',
                            points:0,
                            likeCount: '0',
                            cmntCount:'0',
                            shareCount:'0',
                            imgCount:'0',
                            videoCount:'0',
                            pollCount:post.cnt != null?post.cnt:0,
                            total:post.cnt != null?post.cnt:0,
                        }
                    }
                       
                });   
                const da = await Promise.all(promises);
                da.map((f) => {
                    if(f) {
                        finalData.push({
                            userId:f.userId,
                            userName: f.userName,
                            profilePic:f.profilePic ,
                            points:f.points,
                            likeCount:f.likeCount,
                            cmntCount:f.cmntCount,
                            shareCount:f.shareCount,
                            imgCount:f.imgCount,
                            videoCount:f.videoCount,
                            pollCount:f.pollCount,
                            total:f.total                        
                        })
                    }     
                }) 
                if(finalData.length > 0) {
                    response.status = true;
                    response.data = finalData;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99908,'Data not found')
                }
                
            }
            return response;
        } catch(error) {
            throw error;
        }        
    }
}
